import script from "./projectweekstatuslist.vue?vue&type=script&setup=true&lang=ts"
export * from "./projectweekstatuslist.vue?vue&type=script&setup=true&lang=ts"

import "./projectweekstatuslist.vue?vue&type=style&index=0&id=6a109f29&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a109f29"]])

export default __exports__